<ion-content class="ion-no-padding">
  <div class="lead-form itinerary-model-container">
    <div class="itinerary-model-header">
      <ion-header class="ion-no-border ion-padding-horizontal sticky-top bg-white">
        <ion-toolbar class="header-first-toolbar">
          <ion-title class="text-start ion-no-padding title-blue">Visa Service Process <span *ngIf="editVisaId">{{(editVisaId)}}</span></ion-title>
          
          <ion-buttons slot="end" class="ion-no-margin">
            <ion-button (click)="closeModal()" class="header-button-cancel unfilled-gray-btn">
              <ion-icon name="close-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
  
      <div class="dashed-line"></div>
  
      <div class="d-flex py-1 flex-wrap ion-padding-horizontal nav-buttons-container">
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'lead',  'tab-green': leadInformation?.dataSaved, 'tab-red': leadInformation?.dataInvalid }"  (click)="onViewChangeFromTab('lead')">Lead</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'details', 'tab-green': leadDetailsFormData?.dataSaved, 'tab-red': leadDetailsFormData?.dataInvalid }"  (click)="onViewChangeFromTab('details')">Lead Information</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'important', 'tab-green': importantInformationFormData?.dataSaved, 'tab-red': importantInformationFormData?.dataInvalid }"  (click)="onViewChangeFromTab('important')" [disabled]="!visaId">Visa Checklist</ion-button>
        <ion-button class="unfilled-black-btn-sm" [ngClass]="{'filled-black-btn-sm': componentView === 'documents', 'tab-green': documentCollectionFormData?.dataSaved, 'tab-red': documentCollectionFormData?.dataInvalid }"  (click)="onViewChangeFromTab('documents')" [disabled]="!visaId">Documents Collection</ion-button>
        <ion-button class="unfilled-black-btn-sm" (click)="openReviewScreen()" [disabled]="!visaId">Review</ion-button>
      </div>
    </div>
    

    <div [ngSwitch]="componentView" class="itinerary-model-content-main">

      <!-- Lead information compoennt -->
      <app-lead-information *ngSwitchCase="'lead'"
      [leadId]="leadId"
      [leadDetails]="leadInformation"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeLeadInformation($event)"
      ></app-lead-information>

      <!-- Visa Lead details component ( storing destination and others) -->
      <app-lead-details  *ngSwitchCase="'details'" [visaId]="visaId"
      [leadId]="leadId"
      [editVisaId]="editVisaId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeLeadDetailsData($event)"
      (storeDocumentsFormData)="storeDocumentsData($event)"
      [storedFormData]="leadDetailsFormData"
      (assignVisaId)="assignVisaId($event)"
      ></app-lead-details>

      <app-visa-important-information  *ngSwitchCase="'important'" [visaId]="visaId"
      [leadId]="leadId"
      [editVisaId]="editVisaId"
      [visaLeadInfo]="leadDetailsFormData"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeImportantInformationData($event)"
      [storedFormData]="importantInformationFormData"
      ></app-visa-important-information>

      <app-document-collection  *ngSwitchCase="'documents'" [visaId]="visaId"
      [leadId]="leadId"
      [editVisaId]="editVisaId"
      (viewChange)="onViewChange($event)"
      (storeFormData)="storeDocumentsData($event)"
      [storedFormData]="documentCollectionFormData"
      [visaLeadDetails]="leadDetailsFormData"
      [visaImportantInfo]="importantInformationFormData"
      (openReviewScreen)="openReviewScreen()"
      ></app-document-collection>

    </div>
  </div>
</ion-content>
